<template>
    <div class="side_container">
                  <div class="xbjj_con">
                    <div class="news_datail">
                      <div class="advice_text2 text-center" v-html="data.Title"></div>
                      <div class="advice_text2_subtitle text-center" v-if="data.SecondTitle" v-html="data.SecondTitle"></div>
                      <div class="news_name text-center"><span >发布时间：{{data.DateCreate}}</span>&nbsp;&nbsp;<span>浏览次数：{{data.Hits}}次</span></div>
                      <div class="news_datail_con" v-html="data.Body">

                      </div>
                    </div>
                   
                    </div>
                </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    props:['data']
}
</script>
<style scoped>
a:hover{
color: #ff9f00 !important;
}
</style>